/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fit_LowInputs */

const en_fit_low = /** @type {(inputs: Fit_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Low fit`)
};

const de_fit_low = /** @type {(inputs: Fit_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedrige Passung`)
};

/**
* | output |
* | --- |
* | "Low fit" |
*
* @param {Fit_LowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fit_low = /** @type {((inputs?: Fit_LowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fit_LowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fit_low(inputs)
	return en_fit_low(inputs)
});